import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components';
import { Routes } from '@/constants';

export const EmptyView = ({
  title,
  subtitle,
  img,
}: {
  title: string;
  subtitle: string;
  img?: string;
}) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        pt: 4,
      }}>
      {img && (
        <Box
          component="img"
          src={img}
          alt={`${title} logo`}
          sx={{ width: 128, height: 128, mb: 2 }}
        />
      )}
      <Typography mb={2} variant="h4">
        {title}
      </Typography>
      <Typography
        mb={3}
        variant="body3"
        sx={{
          color: 'text.main',
          maxWidth: `300px`,
          textAlign: 'center',
        }}>
        {subtitle}
      </Typography>
      <Button
        label="Explore Episodes"
        fullWidth={false}
        onClick={() => navigate(Routes.DISCOVER)}
      />
    </Box>
  );
};
